import { z } from 'zod'

import { AccordionDtoSchema } from '../components'

export const RoomDetailsDtoSchema = z.strictObject({
  imageUrl: z.string().url(),
  accommodationName: z.string(),
  realEstateName: z.string().nullable(),
  size: z.number().int().nonnegative(),
  description: z.string().nullable(),
  checkInHour: z.number().int().gte(0).lte(23),
  checkOutHour: z.number().int().gte(0).lte(23),
  content: z.array(AccordionDtoSchema),
})

export type RoomDetailsDto = z.infer<typeof RoomDetailsDtoSchema>

export const isRoomDetailsDto = (x: unknown): x is RoomDetailsDto => RoomDetailsDtoSchema.safeParse(x).success
